import React from 'react';

import {MainLayout} from 'widgets/layout';
import {listPageClassName} from 'shared/ui/ListPage/ListPage';

import {StatusPages} from 'features/statusPage';

const StatusPagesPage: React.FC = () => {
    return (
        <MainLayout className={listPageClassName}>
            <StatusPages />
        </MainLayout>
    );
};

export default StatusPagesPage;
